<script lang="ts">
  import type { DealerTheme } from "conversion_flows/shared/contexts/dealerTheme"
  import { createEventDispatcher, getContext } from "svelte"
  import type { Settings } from "website_script/types/settings"
  import type { Texts } from "website_script/types/texts"
  import themeTokens from "conversion_flows/theme/LibUIThemeTokens"
  import Svg from "./Svg.svelte"
  import AUButton from "component_library/components/svelte/ui/AUButton.svelte"
  import AUText from "component_library/components/svelte/ui/AUText.svelte"
  import Call from "@autouncle/icons/dist/assets/call.svg?raw"
  import { trackFunction } from "website_script/lib/tracking"

  const { contactPhoneNumber }: Settings = getContext("settings")
  const { callFlow }: Texts = getContext("texts")
  const dealerTheme = getContext<DealerTheme>("dealerTheme")

  const tokens = themeTokens(dealerTheme)

  const dispatch = createEventDispatcher()

  function call() {
    dispatch("flowEvent", {
      action: "completeFlow",
      data: null,
    })
    trackFunction({
      entity: "call",
      action: "clicked",
      type: "interacted_with_cta",
      flow: "call",
    })
    window.open(`tel:${contactPhoneNumber}`, "_self")
  }
</script>

<div class="au-call-flow">
  <AUText color="default" font="body-base" weight="bold"
    >{callFlow.title}</AUText
  >
  <AUText color="body" font="body-small">{callFlow.text}</AUText>
  <AUButton fullWidth onClick={call}>
    <Svg
      color={String(tokens("colors.primaryContrastForeground"))}
      alt={callFlow.title}
      aria-hidden="true"
      data={Call}
      slot="leftIcon"
    />
    {contactPhoneNumber}
  </AUButton>
</div>

<style>
  .au-call-flow {
    display: flex;
    flex-direction: column;
    gap: var(--au-spacing-lg);
  }
</style>
